import React__default from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import IconRouter from './IconRouter.js';
import { c as commonPropTypes } from './commonPropTypes-8c108b82.js';
import { i as isFunction } from './helpers-f6b58b19.js';

var styles = {"input":"Input-module_input__2QWj5","labelContainer":"Input-module_labelContainer__2Kd2Y","input-icon":"Input-module_input-icon__1KcIz","input-intent-success":"Input-module_input-intent-success__wz4hC","input-intent-error":"Input-module_input-intent-error__VwYSy","input-disabled":"Input-module_input-disabled__1nVpd","clickable":"Input-module_clickable__jnNmc","input-select":"Input-module_input-select__UY3TF","input-add":"Input-module_input-add__2DMCo","input-loading":"Input-module_input-loading__KkcDB","input-search":"Input-module_input-search__170ce","input-clear":"Input-module_input-clear__3MTX9","input-large":"Input-module_input-large__2M7ma","input-money":"Input-module_input-money__2buKS","input-vrm":"Input-module_input-vrm__2iNoI","input-no-icon":"Input-module_input-no-icon__19H2I","input-icon-loading":"Input-module_input-icon-loading__1HjBS","rotate":"Input-module_rotate__9-x-7","input-icon-left":"Input-module_input-icon-left__2x1Q1","leftIcon":"Input-module_leftIcon__1uXoO","rightIcon":"Input-module_rightIcon__1PLyE","input-icon-clear":"Input-module_input-icon-clear__1k827","control":"Input-module_control__2VSW6"};

/* eslint-disable max-len, jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events, jsx-a11y/control-has-associated-label */
const InputIcon = ({
  className,
  icon = null,
  inputFocused = false,
  onClick = () => {}
}) => {
  const iconSvg = /*#__PURE__*/React__default.createElement(IconRouter, {
    iconName: icon
  });
  if (iconSvg) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: cx(styles['input-icon'], styles[`input-icon-${icon}`], {
        [styles.clickable]: onClick,
        [styles.rotate]: inputFocused
      }, className),
      onMouseDown: event => {
        if (isFunction(onClick)) {
          onClick(event);
        }
      }
    }, iconSvg);
  }
  return null;
};
InputIcon.propTypes = {
  className: commonPropTypes.className,
  icon: PropTypes.string,
  inputFocused: PropTypes.bool,
  onClick: PropTypes.func
};

export { InputIcon as I, styles as s };
